import { setCookie } from "nookies";
import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Help from "../../components/Help";
import ModeButton from "../../components/ModeButton";
import { AuthContext } from "../../contexts/Authentication/AuthContext";
import { LoadingContext } from "../../contexts/Loading/LoadingContext";
import sendDataToCustomerX from "../../services/customerXTracking";
import Logout from "./Profile";
import UserPages from "./UserPages";
import "./styles.css";

const Home = ({ newPage }: { newPage?: boolean }) => {
  const {
    isAuthenticated,
    user,
    account,
    homeAcess,
    memcacheLogin,
    hasShortToken,
    getShortToken,
  } = useContext(AuthContext);
  const { changeVisibility } = useContext(LoadingContext);
  const { shortToken } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated || hasShortToken) {
      document.title = "Página Inicial - Torre Logística de Entregas - TLE - " + account;
      sendDataToCustomerX("PaginaInicialTLE");
    }
    if (shortToken && !isAuthenticated) {
      changeVisibility(true);
      getShortToken(shortToken).then((hasShortToken: boolean) => {
        if (!hasShortToken) {
          if (shortToken?.slice(0, 3) === "ctl") {
            memcacheLogin(shortToken);
          } else {
            navigate("/login");
          }
        }
      });
    } else if (!isAuthenticated) {
      navigate("/login");
    }
    if (homeAcess === "1") {
      setCookie(undefined, "controlTower.homeAcess", "0", {
        maxAge: 60 * 60 * 24, //7 dias
        path: "/",
      });
    }
  }, []);

  return isAuthenticated || hasShortToken ? (
    <>
    {/* <head> 
    <script async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_TRACKING_ID}`}></script> 
    <script dangerouslySetInnerHTML={{
      __html: `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag("js", new Date());
      gtag("config", '${process.env.REACT_APP_TRACKING_ID}', {
        page_path: window.location.pathname,
      });`
    }}  
    />
    </head> */}

    <div className="page-home">
      <div className="content-home">
        <div className="text-center">
          <div className="row">
            <div className="col-12 d-flex justify-content-center justify-content-md-between align-items-center w-100 mb-2">
              <h3 className="title-home">Torre Logística de Entregas</h3>
              <p className="home-brand-text">TNS Gestão de Entregas</p>
            </div>
            <div className="col-12 home-sub-header">
              <div className="info_username_left">
                {account}
                <div>{user}</div>
              </div>
              <div className="home-sub-header-controls">
                <Logout />
                <ModeButton />
                <Help />
              </div>
            </div>
          </div>
          <div className="content-home-middle">
            <UserPages newPage={newPage} />
          </div>
        </div>
      </div>
    </div>
    </>
  ) : (
    <></>
  );
};

export default Home;
